export class FiltroIdeoneidad {
    dniUsuario: String;
    codAsesor: String[];
    ramo: String;
    subramo: String;
    producto: String;
    operacion: String;
    aplicacion: String;
    accion: String;
    compania: String;
    pais: String;

    constructor(dniUsuario: String, codAsesor: String[], ramo: String, subramo: String, producto: String, operacion: String,
        aplicacion: String, accion: String, compania: String, pais: String) {
        this.dniUsuario = dniUsuario;
        this.codAsesor = codAsesor;
        this.ramo = ramo;
        this.subramo = subramo;
        this.producto = producto;
        this.operacion = operacion;
        this.aplicacion = aplicacion;
        this.accion = accion;
        this.compania = compania;
        this.pais = pais;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/filtro/filtro-idoneidad.ts